import Vue from 'vue';
import posthog from 'posthog-js';
import env from 'config/env';
export function install() {
    Vue.prototype.$posthog = posthog.init(env.POSTHOG_API_KEY, {
        api_host: env.POSTHOG_HOST,
        opt_in_site_apps: true,
        session_recording: {
            maskTextSelector: '.contains-pii',
        },
    });
    if (env.APP_ENV === 'development') {
        posthog.debug();
    }
}
